import { Course } from '../../../typings';
import { getFetch } from '../fetch';

import { apiConfig } from '../config';

/** Если classId не передается, то запрашиваются все курсы */
export function getCourses(classId?: number): Promise<Array<Course>> {
    const { apiGetCourses } = apiConfig.getStaticUrls();

    return getFetch(apiGetCourses, {
        team: classId,
    });
}
